export default __webpack_public_path__ + "static/media/m-34.234050fb.svg";